import { createChildListViewContainer } from 'factories/ChildListView'
import Component from 'components/Assets/Tolerances'

export default createChildListViewContainer()(Component)
